import { FunctionComponent } from 'react';
import classnames from 'classnames';

// components
import Anchor from '@Components/Utils/Anchor';

// Contexts
import { useCategory } from '@Components/Categories/Context';

// styles
import styles from './CategoryCard.module.scss';

interface CategoryCardProps {
    className?: string;
}

const CategoryCard: FunctionComponent<CategoryCardProps> = ({ className }) => {
    const { categoryObjs } = useCategory();

    const wrapperClassName = classnames([styles.wrapper, className]);

    return (
        <div className={wrapperClassName}>
            <div className={styles.title}>Danh mục</div>
            <div className={styles.items}>
                {categoryObjs &&
                    Object.values(categoryObjs).map((category) => (
                        <Anchor
                            className={styles.item}
                            style={{ background: category.color }}
                            href={`/bai-viet/danh-muc/${category.slug || category.id}`}
                            key={`category-item-${category.id}`}
                        >
                            {category.title}
                        </Anchor>
                    ))}
            </div>
        </div>
    );
};

CategoryCard.defaultProps = {
    className: '',
};

export default CategoryCard;
